import React from "react";

export default function Contact() {
  return (
    <div style={{
      height: "100vh",
      background: "radial-gradient(ellipse at bottom, #0b0c2a 0%, #000000 100%)",
      color: "white",
      textAlign: "center",
      overflow: "hidden"
    }}>
      <style>
        {`
        .container {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }

        .planet {
          width: 120px;
          height: 120px;
          margin: 30px auto;
          border-radius: 50%;
          background: radial-gradient(circle at 30% 30%, #00eaff, #001f4d);
          box-shadow: 0 0 30px #00eaff;
          animation: rotate 20s linear infinite;
        }

        @keyframes rotate {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }

        h1 {
          font-size: 48px;
          text-shadow: 0 0 10px #00eaff,
                       0 0 20px #00eaff,
                       0 0 40px #0088ff;
        }
        `}
      </style>

      <div className="container">
        <div className="planet"></div>
        <h1>Under Maintenance</h1>
        <p>Buyer Login is upgrading. Please check back soon.</p>
      </div>
    </div>
  );
}
